import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Permission} from '../../../models/permission.model';
import {UserGroup} from '../../../models/user-group.model';
import {Constants} from '../../../shared/utils/constants';
import {UserSettingsService} from '../user-settings.service';
import {AppService} from '../../../app.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'fx-group-operator',
  templateUrl: './group-operator.component.html',
  styleUrls: ['./group-operator.component.sass']
})
export class GroupOperatorComponent implements OnInit, OnDestroy {
  @Input() permission: Permission;
  @Input() groups: UserGroup[];
  @Output() dataLoaded = new EventEmitter();
  @ViewChild('form', { static: false }) form: NgForm;
  @ViewChild('modalGroup', { static: false }) modalGroup: ElementRef;
  group: UserGroup = new UserGroup();
  manageGroupMode: string;
  subscription: any = {};
  showError = false;
  permissionColors = ['#9897a7', '#ffcf07', '#6cb763'];
  constructor(private appService: AppService,
              private userSettingsService: UserSettingsService
  ) {}

  ngOnInit(): void {
  }

  createGroup(group: UserGroup): void {
    this.subscription.createGroup = this.userSettingsService
      .createGroup(group)
      .subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.showError = false;
          this.appService.showSuccess('Create Group Successful!');
          this.dataLoaded.emit(new Date().getTime());
          this.modalGroup.nativeElement.querySelector('button.close').click();
        } else {
          this.appService.showError(data.message || 'Create Group Failed!');
        }
      });
  }

  updateGroup(group: UserGroup): void {
    this.subscription.updateGroup = this.userSettingsService
      .updateGroup(group)
      .subscribe(data => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.showError = false;
          this.appService.showSuccess('Update Group Successful!');
          this.dataLoaded.emit(new Date().getTime());
          this.modalGroup.nativeElement.querySelector('button.close').click();
        } else {
          this.appService.showError(data.message || 'Update Group Failed!');
        }
      });
  }
  addGroup(): void {
    this.manageGroupMode = 'Add';
    this.group = new UserGroup();
  }

  editGroup(group: UserGroup): void {
    this.manageGroupMode = 'Edit';
    this.group = group;
  }

  save(): any {
    this.showError = true;
    if (this.form.valid) {
      if (this.manageGroupMode === 'Add') {
        this.createGroup(this.group);
      } else {
        this.updateGroup(this.group);
      }
    }
  }

  ngOnDestroy(): void {
    for (const key in this.subscription) {
      if (this.subscription.hasOwnProperty(key) && this.subscription[key]) {
        this.subscription[key].unsubscribe();
      }
    }
  }
}
